import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { LOGO_URL } from "../config";
import { useLang } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MagicLogin() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { lang } = useLang();
  const ar = lang === "ar";
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/auth/magic/${token}`)
      .then((res) => {
        localStorage.setItem("themaya_customer_token", res.data.access_token);
        navigate(res.data.course_id ? `/watch/${res.data.course_id}` : "/account", { replace: true });
      })
      .catch((err) => setError(err.response?.data?.detail || (ar ? "الرابط غير صالح" : "Invalid link")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen bg-luxury-black flex items-center justify-center px-4" data-testid="magic-login-page">
      <div className="text-center border border-luxury-border bg-luxury-surface p-12 max-w-md w-full">
        <img src={LOGO_URL} alt="TheMaya" className="h-10 mx-auto mb-6" />
        {error ? (
          <>
            <XCircle className="w-12 h-12 mx-auto mb-4 text-red-400" strokeWidth={1.25} />
            <p className="text-luxury-bone font-serif text-2xl mb-6" data-testid="magic-login-error">{error}</p>
            <Link to="/account" data-testid="magic-login-account-link" className="bg-luxury-gold text-luxury-black font-semibold px-8 py-3 rounded-full hover:bg-luxury-goldLight transition-colors inline-block">
              {ar ? "صفحة حسابك" : "Your account"}
            </Link>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 mx-auto mb-4 text-luxury-gold animate-spin" />
            <p className="text-luxury-bone font-serif text-2xl">{ar ? "جارٍ تسجيل دخولك..." : "Signing you in..."}</p>
          </>
        )}
      </div>
    </div>
  );
}
